export const LICENSING_SOLUTIONS = [
    {
        iconName: "config_drift_audit",
        label: "CDA",
        fullName: "Config Drift and Audit",
    },
    {
        iconName: "os_manager",
        label: "OSM",
        fullName: "OS Manager",
    },
    {
        iconName: "model_editor",
        label: "CME",
        fullName: "Config Model Editor",
    },
    {
        iconName: "workflow",
        label: "WKF",
        fullName: "Workflows",
    },
    {
        iconName: "rpa",
        label: "RPA",
        fullName: "Robotic Process Automation",
    },
    {
        iconName: "topology",
        label: "TOP",
        fullName: "Topology",
    },
    {
        iconName: "gluware_titan",
        label: "TAI",
        fullName: "Gluware Titan",
    },
];

export const LICENSING_CONTENT_FULL_DATA_TEST_ID = "licensing-content-full";
export const LICENSING_SOLUTIONS_LIST_DATA_TEST_ID = "licensing-solutions-list";
export const UNLIMITED = "Unlimited";
export const PERPETUAL = "Perpetual";
